import { HumanDollyIcon } from './HumanDollyIcon';

/**
 * author: Michael Irigoyen
 * id 24AA9CD4-6B25-4B7C-A3A2-0C1A29DC5E1F
 * name human-dolly
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-dolly.svg
 * tags
 * - People / Family 
 */
export const HumanHandTruckIcon = HumanDollyIcon;
export default HumanHandTruckIcon